import { Component } from '@angular/core';
import { LocalStorageManager } from '@cutting/main/shared/helper/local-storage-manager.helper';
import { fuseAnimations } from '@fuse/animations';
import { FuseConfigService } from '@fuse/services/config.service';

@Component({
  selector: 'cutting-account-activated',
  templateUrl: './account-activated.component.html',
  styleUrls: ['./account-activated.component.scss'],
  animations: fuseAnimations,
})
export class AccountActivatedComponent {
  get userId(): number {
    return LocalStorageManager.regData;
  }

  constructor(private fuseConfigService: FuseConfigService) {
    this.fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        toolbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        sidepanel: {
          hidden: true,
        },
      },
    };
  }
}
